<template>
  <div class="category-noResult" :class="{'loading': status == 3 && isCategory}">
    <div class="noResult" v-show="status != 3">
      <div class="empty-search-pic" :class="{'err-search-pic': status == 2}"></div>
      {{status | showStatus}}
    </div>
    <button class="reload-btn" @click="$emit('reloadData')" v-show="status == 2">重新加载</button>
  </div>
</template>

<script>
  export default {
    props: {
      status: {
        type: Number,
        default: 1 // 1-暂无数据 2-加载失败 3-加载中
      },
      isCategory: {
        type: Boolean,
        default: false
      }
    },
    filters: {
      showStatus(val) {
        let str = '小主请稍等...'
        if (val == 1) {
          str = '当前分类暂无数据'
        } else if(val == 2) {
          str = '诶？信号哪去了'
        }
        return str
      }
    }
  }
</script>

<style lang="less" scoped>
.category-noResult{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  font-size: 0.28rem;
  color: #9A9A9A;
  border-radius: 0.12rem;
  background-color: #fff;
  &.loading{
    background-image: url('./bg-loading.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .noResult{
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.2rem;
    .empty-search-pic{
      width: 1.5rem;
      height: 1.5rem;
      margin-bottom: 0.2rem;
      background-image: url('//static.yunjiweidian.com/qnUpload/frontend/error/E4.png');
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .err-search-pic{
      background-image: url('//static.yunjiweidian.com/qnUpload/frontend/logo/icon-nodata.png');
    }
  }
  .reload-btn{
    padding: 0.12rem 0.48rem;
    font-size: 0.28rem;
    border: none;
    background-color: #f2f2f2;
    border-radius: 0.32rem;
  }
}
</style>